import { render } from "./AlertsChips.vue?vue&type=template&id=ed3157fa&scoped=true"
import script from "./AlertsChips.vue?vue&type=script&lang=js"
export * from "./AlertsChips.vue?vue&type=script&lang=js"

import "@/styles/global.css?vue&type=style&index=0&lang=css&external"
import "./AlertsChips.vue?vue&type=style&index=1&id=ed3157fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3157fa"]])

export default __exports__